export default childElements => childElements.filter(item => item.tag === 'li');



// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/html/elements/list/helpers/pickLiChildElements.js